// extracted by mini-css-extract-plugin
export default {"inputBox":"Payment_inputBox__ADKSG"};